<template>
  <div class="px-5 py-5">

    <h2 id="campaign=data" class="mt-3 mb-3">Campaign Data</h2>

    <div class="mb-5 grid grid-cols-1 gap-2 sm:grid-cols-4 sm:grid-cols-3">

      <div >
        <p class="block text-sm font-medium text-gray-700"> Year </p>
        <select v-model="selectedYear" @change="filterYear()" class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option value=""></option>
          <option  v-for="year in years"  :value="year"> {{year }}</option>
        </select>
      </div>

      <div v-if="this.admin" >
        <p class="block text-sm font-medium text-gray-700"> Foundation Campaign </p>
        <select v-model="selectedFoundationCampaign" @change="filterFoundation()" class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option value=""></option>
          <option  v-for="foundationCampaign in foundationCampaigns"  :value="foundationCampaign.id"> {{foundationCampaign.name }}</option>
        </select>
      </div>

      <div >
        <p class="block text-sm font-medium text-gray-700"> Campaign Level </p>
        <select v-model="selectedSubCampaign" @change="filter()" class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option value=""></option>
          <option  v-for="subCampaign in subCampaigns"  :value="subCampaign.id"> {{subCampaign.name }}</option>
        </select>
      </div>

      <div >
        <p class="block text-sm font-medium text-gray-700"> Stat </p>
        <select v-model="selectedStatType" @change="filter()" class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <option  v-for="(statType, key) in statTypes"  :value="key"> {{statType}}</option>
        </select>
      </div>

    </div>

    <h2 class="mb-3">({{this.selectedYear}}) {{this.statName}} - {{this.statValue}}</h2>

    <div class="xl:border border-gray-200">
      <div class="hidden xl:flex xl:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
        <div class="xl:w-1/12">&nbsp;</div>
        <div class="xl:w-1/12">ID</div>
        <div class="xl:w-6/12">Name</div>
        <div class="xl:w-1/12">Goal</div>
        <div class="xl:w-1/12">Total</div>
        <div class="xl:w-1/12">Created At</div>
        <div class="xl:w-1/12">&nbsp;</div>
      </div>
      <div class="flex flex-col space-y-3 xl:space-y-0">

        <div v-for="campaign in campaigns" class="flex flex-col xl:flex-row xl:px-6 xl:py-3 bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 xl:border-b xl:border-gray-50 xl:border-l-0 xl:border-t-0 xl:border-r-0 xl:items-start">

          <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              Avatar
            </div>
            <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center">
              <img class="w-10"  :src="campaign.thumbnail_logo ? campaign.thumbnail_logo : '/img/side-out-iconcircle.png'">
            </div>
          </div>

          <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              ID
            </div>
            <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
              {{ campaign.id }}
            </div>
          </div>

          <div class="flex flex-row w-full items-center xl:w-6/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              Name
            </div>
            <div class="flex flex-col items-center xl:items-start justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
              <div>
                {{ campaign.name }}

                <div  v-if="campaign.user_id"  class="relative hidden xl:inline-flex">
                  <a v-tooltip="{ content: getContentCampaignUser(campaign)}">
                    <i class="fas fa-user text-blue ml-2 text-lg"></i>
                  </a>
                </div>

                <div  v-if="campaign.ownership == 'business' || campaign.ownership == 'school'"   class="relative hidden xl:inline-flex">
                  <a v-tooltip="{ content: getContentCampaignOwner(campaign)}">
                    <i class="fas fa-users text-base ml-2 text-x"></i>
                  </a>
                </div>

              </div>
              <span v-html="getBreadcrumbs(campaign)"></span>
            </div>
          </div>

          <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              Goal
            </div>
            <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
              $ {{ campaign.goal }}
            </div>
          </div>

          <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              Total
            </div>
            <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
              $ {{ campaign.total_raised_directly_in_this_campaign }}
            </div>
          </div>

          <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              Created At
            </div>
            <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
              {{ formatDate(campaign.created_at) }}
            </div>
          </div>

          <div class="flex flex-row w-full items-center xl:w-1/12 bg-gray-100 xl:bg-transparent justify-end xl:text-base items-stretch">
            <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
              Actions
            </div>
            <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-center text-gray-500">
              <campaign-search-crud-button :user="user" :campaign="campaign" :key="campaign.id" ></campaign-search-crud-button>

            </div>
          </div>


        </div>

      </div>
    </div>



  </div>
</template>

<script>
import { ArrowSmDownIcon, ArrowSmUpIcon } from '@heroicons/vue/solid'
import CampaignStatsItem from "./CampaignStatsItem";
import moment from "moment";


export default {
  components: {
    CampaignStatsItem,
    ArrowSmDownIcon,
    ArrowSmUpIcon,
  },
  data() {


    return {
      user: {},
      years: {},
      admin: false,
      selectedYear: 2022,
      selectedFoundationCampaign: null,
      selectedSubCampaign: null,
      foundationCampaigns: [],
      subCampaigns: [],
      campaigns: {},
      donations: {},
      selectedStatType: 'parentCampaigns',
      statTypes: [],
      statValue: null,
      statName: null,
    }
  },
  created() {
    axios.get('/reports/campaign-stat-list-initial')
        .then(response => {
          this.years =  response.data.years
          this.selectedYear =  response.data.mostRecentYear
          this.foundationCampaigns =  response.data.foundationCampaigns
          this.admin =  response.data.admin
          this.user =  response.data.user
          this.subCampaigns =  response.data?.subCampaigns ?? []
          this.statTypes =  response.data?.statTypes ?? []

          this.setSubCampaign()

          this.filter()
        })
  },
  methods: {
    setSubCampaign() {
      if (this.subCampaigns.length === 1) {
        this.selectedSubCampaign = this.subCampaigns[0].id
      }
    },
    filterYear() {
      this.selectedFoundationCampaign = null
      this.selectedSubCampaign = null
      this.filter()
    },
    filterFoundation() {
      this.selectedSubCampaign = null
      this.filter()
    },
    filter() {
      if (!this.selectedYear) {
        return
      }

      let formData = {
        selectedYear: this.selectedYear,
        selectedFoundationCampaign: this.selectedFoundationCampaign,
        selectedSubCampaign: this.selectedSubCampaign,
        selectedStatType: this.selectedStatType,
      }
      axios.post('/reports/campaign-stat-list-get', formData)
          .then(response => {
            this.campaigns =  response.data?.statsData?.campaigns?.data
            this.statValue =  response.data?.statsData?.statValue
            this.statName =  response.data?.statsData?.name
            this.donations =  response.data?.statsData?.donations?.data
            this.subCampaigns =  response.data.subCampaigns
            this.foundationCampaigns =  response.data.foundationCampaigns

            this.setSubCampaign()

          })
    },

    getContentCampaignUser(campaign) {
      return campaign.user_name + ' ('+ campaign.email+')'
    },
    getContentCampaignOwner(campaign) {
      return campaign.business_name + ' ('+ campaign.city+', '+campaign.state+')'
    },
    getBreadcrumbs(campaign) {
      let breadcrumbLinks = []
      let breadcrumbs = JSON.parse(campaign.breadcrumbs)

      _.forEach(breadcrumbs, function(value, key) {
        if (value?.id != campaign.id) {
          breadcrumbLinks.push("<a target='_blank' class=' text-pink hover:text-gray text-xs mt-2' href='/campaigns/"+value?.id+"'>"+value?.name+"</a>")
        }
      });
      return _.join(breadcrumbLinks, [' / ']);
    },
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY')
    },
  },
}
</script>
